var Either = require('./src/either');

if (typeof module != 'undefined')
    module.exports = Either;
